<i18n lang='yml' src='../i18n/SittingForm.yml'></i18n>
<template>
  <div>
    <div class="layout-tile">
      <div class="heading-block d-flex">
        <h4>
          <span>
            {{type == 'new' ? $t('header') : $t('update')}}
          </span>
        </h4>
      </div>
      <flash :message_type="message_type" :message_text="message_text"/>
      <Form ref="observer" v-slot="{ errors }" @submit="submitUserInput" @invalid-submit="setErrorMessage">
          <fieldset class="form-group border-bottom mt-4">
            <div class="row">
              <div class="col-md-12 col-lg-9">
                <div class='form-group row'>
                  <div class='col-md-4'>
                    <Field
                      :name="$t('date')"
                      :rules="`required|date_not_in_past:@${$t('start_time')}`"
                      v-slot="{ errors, ariaMsg, field }"
                      v-model='sitting.date'>
                      <label for="date">
                        {{$t('date')}}
                      </label>
                      <flat-pickr :config="dateConfig"  class="form-control"  input-class='form-control' :id="$t('date')"
                        name="date"
                        ref="date"
                        v-bind="field"
                        v-model='sitting.date'
                        :class="{'is-invalid': errors[0]}" ></flat-pickr>
                      <div v-bind="ariaMsg" class="invalid-feedback" id="date" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span>
                        </div>
                    </Field>
                  </div>
                  <div class='col-md-4'>
                    <Field
                      :name="$t('start_time')"
                      :rules="`time_not_in_past:@${$t('date')}`"
                      v-slot="{ errors, ariaMsg, field }"
                      v-model='sitting.start_time'>
                      <label :for="$t('start_time')">
                        {{$t('start_time')}}
                      </label>
                      <flat-pickr
                        :config="timeConfig"
                        class="form-control"
                        input-class='form-control'
                        ref="start_time"
                        :id="$t('start_time')"
                        name="start_time"
                        v-model='sitting.start_time'
                        v-bind="field"
                        :class="{'is-invalid': errors[0]}"
                        ></flat-pickr>
                      <div class="invalid-feedback" v-bind="ariaMsg"
                      id="start_time" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span>
                      </div>
                      <input type="hidden" :value="`${sitting.start_time} ${timezone}`">
                    </Field>
                  </div>
                  <div class='col-md-4'>
                    <Field
                      :name="$t('end_time')"
                      :rules="`required|not_before_start_time:@${$t('start_time')}|time_not_in_past:@${$t('date')}`"
                      v-slot="{ errors, ariaMsg, field }"
                      v-model='sitting.end_time'>
                      <label :for="$t('end_time')">
                        {{$t('end_time')}}
                      </label>
                      <flat-pickr :config="timeConfig"
                        class="form-control"
                        input-class='form-control'
                        :id="$t('end_time')"
                        name="end_time"
                        v-model='sitting.end_time'
                        v-bind="field"
                        :class="{'is-invalid': errors[0]}"></flat-pickr>
                      <div class="invalid-feedback" v-bind="ariaMsg" id="end_time" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span>
                        </div>
                      <input type="hidden" :value="`${sitting.endTime} ${timezone}`">
                    </Field>
                    <input type="hidden" :value="`${sitting.endTime} ${timezone}`">
                  </div>
                </div>
                <div class="form-group row" >
                  <div class='col-md-5'>
                    <Field
                      :name="$t('number_of_seats')"
                      vid="number_of_seats"
                      :rules="privateRoomEnabled ? 'required|numeric' : 'required|numeric|greater_than_zero'"
                      v-model="sitting.number_of_seats"
                      v-slot="{ errors, ariaMsg, ariaInput, field }">
                      <label :for="$t('number_of_seats')">
                        {{$t('number_of_seats')}}
                      </label>
                      <span class="red">*</span>
                      <input
                        :id="$t('number_of_seats')"
                        name="number_of_seats"
                        type="number"
                        class="form-control"
                        v-bind="field"
                        maxlength="4"
                        :class="{'is-invalid': errors[0]}"
                        >
                      <div class="invalid-feedback" v-bind="ariaMsg"
                      id="number_of_seats" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span>
                        </div>
                    </Field>
                  </div>
                </div>
                <div class="form-group">
                  <label>{{$t('local_only')}}</label>
                  <span class="red">*</span>
                  <div class="col-sm-6">
                    <div class="form-check form-check-inline">
                      <label class="form-check-label" :for="`${$t('local_only')}_true`" >
                        <input type="radio" :id="`${$t('local_only')}_true`"
                        :value="true" v-model="sitting.local_only" >
                        {{$t('yes_val')}}
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label" :for="`${$t('local_only')}_false`" >
                        <input type="radio" :id="`${$t('local_only')}_false`"
                        :value="false" v-model="sitting.local_only" >
                        {{$t('no_val')}}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>{{$t('allow_online_booking')}}</label>
                  <span class="red">*</span>
                  <div class="col-sm-6">
                    <div class="form-check form-check-inline">
                      <label class="form-check-label" :for="`${$t('allow_online_booking')}_true`" >
                        <input type="radio" :id="`${$t('allow_online_booking')}_true`"
                         :value="true" v-model="sitting.allow_online_booking" >
                        {{$t('yes_val')}}
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label" :for="`${$t('allow_online_booking')}_false`" >
                        <input type="radio" :id="`${$t('allow_online_booking')}_false`"
                        :value="false" v-model="sitting.allow_online_booking" >
                        {{$t('no_val')}}
                      </label>
                    </div>
                  </div>
                </div>


                <div class="form-group">
                    <label>
                      {{$t('exam_booth_available')}}
                    </label>
                    <span class="red">*</span>
                    <div class="col-sm-6">
                      <div class="form-check form-check-inline" :class="{'is-invalid': errors[0]}">
                        <label class="form-check-label" :for="`${$t('exam_booth_available')}_true`" >
                          <input
                            type="radio"
                            :id="`${$t('exam_booth_available')}_true`"
                            :name="`${$t('exam_booth_available')}_true`"
                            :aria-checked="`${$t('exam_booth_available')}_true`"
                            @click="setBoothCapacity(2)"
                            :value="true"
                            ref="exam_booth_available"
                            v-model="sitting.exam_booth_available">
                          {{$t('yes_val')}}
                        </label>

                      </div>
                      <div class="form-check form-check-inline" :class="{'is-invalid': errors[0]}">
                        <label class="form-check-label" :for="`${$t('exam_booth_available')}_false`">
                          <input
                            type="radio"
                            :id="`${$t('exam_booth_available')}_false`"
                            :name="`${$t('exam_booth_available')}_false`"
                            :aria-checked="`${$t('exam_booth_available')}_false`"
                            :value="false"
                            @click="setBoothCapacity()"
                            v-model="sitting.exam_booth_available" >
                          {{$t('no_val')}}</label>
                      </div>
                    </div>

                </div>

                <div class="form-group row" >
                  <div class='col-md-5'>
                    <Field
                      :name="$t('booth_capacity')"
                      vid="booth_capacity"
                      :rules="privateRoomEnabled ? 'required|numeric|greater_than_zero' : ''"
                      v-model="sitting.booth_capacity"
                      v-slot="{ errors, ariaMsg, ariaInput, field }">
                      <label :for="$t('booth_capacity')">
                        {{$t('booth_capacity')}}
                      </label>
                      <span class="red">*</span>
                      <input
                        :id="$t('booth_capacity')"
                        name="booth_capacity"
                        type="number"
                        maxlength="4"
                        class="form-control"
                        :class="{'is-invalid': errors[0]}"
                        v-bind="field"
                        :disabled="!privateRoomEnabled">
                      <div class="invalid-feedback" v-bind="ariaMsg" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        {{ errors[0] }}
                      </div>
                    </Field>

                  </div>
                </div>

                <div class="form-group">
                  <label>{{$t('extra_time_available')}}</label>
                  <span class="red">*</span>
                  <div class="col-sm-6">
                    <div class="form-check form-check-inline">
                      <label class="form-check-label" :for="`${$t('extra_time_available')}_true`">
                        <input type="radio" :id="`${$t('extra_time_available')}_true`"
                        :value="true" v-model="sitting.extra_time_available" >
                        {{$t('yes_val')}}
                      </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <label class="form-check-label" :for="`${$t('extra_time_available')}_false`">
                        <input type="radio" :id="`${$t('extra_time_available')}_false`"
                        :value="false" v-model="sitting.extra_time_available" >
                        {{$t('no_val')}}
                      </label>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-6">
                  <label> {{$t('status')}} </label>
                  <span class="red">*</span>
                  <select v-model="sitting.status" id="status"  :disabled="saveSittingStatus=='cancelled'" class="form-control">
                    <option v-for="status in sittingStatuses" :key="status.label" :value="status.label" :disabled="status.label=='pending' && sitting.booked_seats > 0">
                      {{$t(status.label)}}
                    </option>
                  </select>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
          <div v-if="Object.keys(errors).length > 0 && showErrorBanner" class="alert alert-danger" role="alert">
            <span class="red mr-2">
              <font-awesome-icon :icon="['far', 'exclamation-circle']"/>
            </span>
            {{ $t('error_warning') }}
          </div>
          <div class="btn-row d-flex">
          <button type="submit" class="btn btn-primary btn-success no-shadow" v-if="type=='new'">
            <font-awesome-icon :icon="['fa', 'save']" />
            {{ $t('create') }}
          </button>
          <template v-else>
            <button  type="submit" :class="!sitting['in_future?'] || saveSittingStatus == 'cancelled' ? 'disabled': ''" class="btn btn-primary btn-success no-shadow">
              <font-awesome-icon :icon="['fa', 'save']" />
              {{ $t('submit') }}
            </button>
            <a class="btn btn-danger" v-if="sitting && sitting.booked_seats == 0" :data-confirm="$t('confirm_delete')" data-method="delete" :href="`${base_path}/${sitting.id}`">   <font-awesome-icon :icon="['fa', 'trash-alt']" />
              {{ $t('delete_session') }}
            </a>
            <a v-else type="delete" @click="deleteAlert()" :class="!sitting['in_future?'] ? 'disabled': ''" class="btn btn-danger no-shadow">
              <font-awesome-icon :icon="['fa', 'trash-alt']" />
              {{ $t('delete') }}
            </a>

          </template>
            <a class="btn btn-light ml-auto" :href="base_path">
            <font-awesome-icon :icon="['fa', 'times']" />
            {{ $t('cancel') }}
          </a>
        </div>
      </Form>
    </div>
    <div v-if="type == 'edit' && sitting">
      <div class="media-list">
        <div class="content-block hide-border mt-4" v-for="item in bookings" :key="item.id">
          <div v-if="item.status != 'cancelled'">
            <div class="post-meta">
              <ul class="list-inline list-annotation">
                <li>
                  <h5 class="container-item-name">
                    {{`${item.user_identity.first_name} ${item.user_identity.last_name}`}}
                    <span v-if="item.user_identity.external_identifiers !== null"> {{item.user_identity.external_identifiers.sto_id}} </span>
                  </h5>
                </li>
                <li v-if="sitting['in_future?']" class="ml-auto">
                  <div class="btn-group btn-group-sm ml-auto" role="group">
                    <a v-if="commentsItem != item.id" class="btn btn-outline-danger" @click.prevent="showComments(item.id)">
                      <font-awesome-icon :icon="['fa', 'times']"/>
                      <span :aria-label="$t('cancel_booking')"> {{ $t('cancel_booking') }} </span>
                    </a>
                    <a v-else class="btn btn-light ml-auto" @click.prevent="showComments(item.id)">
                      <font-awesome-icon :icon="['fa', 'times']"/>
                      <span :aria-label="$t('close')"> {{ $t('close') }} </span>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
            <div class="post-meta">
              <ul class="list-unstyled list-inline list-annotation">
                <li class="list-inline-item">
                  <span class="status-bold">{{$t('trade')}}</span>
                  {{`${item.training_program.trade_code} ${item.training_program.name[locale]}`}}
                </li>
                <li v-if="item.user_identity.phone_number" class="list-inline-item">
                  <span class="status-bold">{{ $t('phone_number') }}</span>
                  {{phoneFormat(item.user_identity.phone_number)}}
                </li>
                <li class="list-inline-item">
                  <span class="status-bold">{{ $t('email_address')}}</span>
                  {{ item.user_identity.email}}
                </li>
                <li class="list-inline-item" v-if="item.booking_accommodations.length > 0">
                  <span class="status-bold">{{ $t('accommodations')}}</span>
                  {{stringifyAccommodations(item.booking_accommodations)}}
                </li>

              </ul>
            </div>
            <div class="flex-table-booking" v-if="commentsItem == item.id" role="rowgroup" >
              <div class="flex-row-full" role="cell">
                <div>
                  <label for="comment"> {{ $t('comments') }} </label>
                </div>
                <div class="comments_section">
                  <textarea class="textareaComments" v-model="commentText" cols="70"/>
                </div>
                <div class="d-flex">
                  <a class="btn btn-danger ml-auto" href="#" :aria-label="$t('cancel_booking')" @click.prevent="cancelBooking(item)">
                    {{$t('cancel_booking') }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <pagination @items_changed="setItems" :items="sitting.active_bookings" :expansion_threshold="expansion_threshold" :pagination_limit="pagination_limit"/>
    </div>
  </div>
</template>

<script>
  import flash from '../../shared/flash_messages/components/Flash.vue'
  import { French } from 'flatpickr/dist/l10n/fr.js';
  import '../../../javascripts/application/vee-validate-rules'
  import { Form, Field } from 'vee-validate'
  import pagination from '../../shared/pagination/Pagination.vue';
  import ScheduledItem from '../../shared/scheduled_items/components/ScheduledItem.vue';
  import { sendAjaxRequest } from '../../shared/typescripts/ajax.ts'
  import { setErrorMessage } from '../../shared/typescripts/error.ts'
  import {commonizeTimeFormat} from '../../shared/typescripts/dates.ts'

  export default {
    props: [
      'locale',
      'base_path',
      'type',
      'sitting_obj',
      'sub_location_name',
      'sitting_statuses',
      'cancellation_path',
      'get_bookings_path',
      'pagination_limit',
      'expansion_threshold'
    ],

    components: {
      'scheduled-item': ScheduledItem,
      flash,
      Form,
      Field,
      pagination
    },

    data() {
      const defaultDate = new Date();
      defaultDate.setHours(0, 0, 0, 0);
      const defaultStartTime = new Date();
      defaultStartTime.setMinutes(0, 0, 0);
      const defaultEndTime = new Date();
      defaultEndTime.setHours(defaultStartTime.getHours() + 1, 0, 0, 0);
      return {
        sitting: {
          exam_booth_available: false,
          extra_time_available: false,
          allow_online_booking: false,
          local_only: false,
          number_of_seats: 1,
          booth_capacity: 0,
          date: this.parseInputDate(defaultDate),
          startTime: this.parseInputTime(defaultStartTime),
          endTime: this.parseInputTime(defaultEndTime),
          status: 'pending'
        },
        defaultDate: defaultDate,
        defaultStartTime: defaultStartTime,
        defaultEndTime: defaultEndTime,
        timezone: new Date().getTimezoneOffset() / 60,
        loading: false,
        error: false,
        message_type: "",
        message_text: [],
        availableLanguages: [],
        statusData: [],
        showErrorBanner: false,
        ariaInput: "",
        ariaMsg: "",
        dateConfig: {
          enableTime: false,
          locale: (this.locale=='fr') ? French : 'en',
          disable: [
            function(date) {
                return (date.getDay() === 0 || date.getDay() === 6);
            },
          ]
        },
        timeConfig: {
          enableTime: true,
          dateFormat: this.locale == 'en' ? "h:iK" : "H\\hi",
          minuteIncrement: 30,
          noCalendar: true,
          time_24hr: this.locale == 'en' ? false : true,
        },
        commentText: null,
        commentsItem: 0,
        saveSittingStatus: '',
        bookingData: {
          booking_id: null,
          user_identity_id: null
        },
        bookings: []
      }
    },

    created() {
      this.$i18n.locale = this.locale;
      try{
        if(this.sitting_obj){
          this.sitting = JSON.parse(this.sitting_obj)
          this.saveSittingStatus = this.sitting.status
          this.sitting.start_time = this.parseInputTime(this.sitting.start_time, this.defaultStartTime)
          this.sitting.end_time = this.parseInputTime(this.sitting.end_time, this.defaultEndTime)
          this.sitting.date = this.parseInputDate(this.sitting.date, this.defaultDate)
          this.sittingStatuses = JSON.parse(this.sitting_statuses)

        } else {
          this.sitting.start_time = this.parseInputTime(this.defaultStartTime)
          this.sitting.end_time = this.parseInputTime(this.defaultEndTime)
          this.sittingStatuses = JSON.parse(this.sitting_statuses)
        }

      }
      catch(err) {
        this.error = true;
      }
    },

    computed: {
      privateRoomEnabled() {
        return this.sitting.exam_booth_available === true;
      }
    },

    methods: {
      setBoothCapacity(value=0) {
        this.sitting.booth_capacity = value
      },
      phoneFormat(input) {
          input = input.replace(/\D/g,'');
          var size = input.length;
          if (size>0) {input="("+input}
          if (size>3) {input=input.slice(0,4)+") "+input.slice(4,11)}
          if (size>6) {input=input.slice(0,9)+"-" +input.slice(9)}
          return input;
      },
      deleteAlert() {
        alert(this.$i18n.t('has_bookings'));
      },
      parseInputDate: function (date, fallback = null) {
          if (date === null) {
              if (fallback === null) {
                  return fallback;
              }

              const year = fallback.getFullYear();
              const month = ('0' + (fallback.getMonth() + 1)).slice(-2);
              const day = ('0' + fallback.getDate()).slice(-2);
              return year + '-' + month + '-' + day;
          }

          const dateObj = new Date(date);
          const parsedDate = new Date(dateObj.getTime() + dateObj.getTimezoneOffset() * 60 * 1000);
          const year = parsedDate.getFullYear();
          const month = ('0' + (parsedDate.getMonth() + 1)).slice(-2);
          const day = ('0' + parsedDate.getDate()).slice(-2);
          return year + '-' + month + '-' + day;
      },
      parseInputTime: function (date, fallback = null) {
          if (date === null) {
              if (fallback === null) {
                  return fallback;
              }
              return fallback.getHours() + ':' + fallback.getMinutes();
          }

          const dateObj = new Date(date);
          let savedHours =  dateObj.getHours()
          let savedMinutes = dateObj.getMinutes()
          return `${savedHours < 10 ? '0' + savedHours : savedHours}:${savedMinutes == 0 ? '00' : savedMinutes}`;
      },
      async handleConfirmations() {
        if(this.sitting.status == "cancelled"){
           return this.sitting.status == "cancelled" && this.sitting.active_bookings && this.sitting.active_bookings.length > 0 ? this.cancellationConfirmation() : true
        }
        else{
          let warningsData = await sendAjaxRequest(
            'POST',
            `${this.base_path}/sitting_warnings`,
            'json',
            {sitting: this.sitting},
            this.successReturn,
            this.throwError
          )
          let confirmAll = true
          Object.keys(warningsData.warnings).forEach((warning) => {
            if(!confirmAll) {
              return
            }
            else if(warningsData.warnings[warning].result) {
              if(!confirm(this.$i18n.t(warning, warningsData.warnings[warning].opts))) {
                confirmAll = false
              }
            }
          })
          return confirmAll
        }
        },
      cancellationConfirmation() {
        if(this.sitting.status == "cancelled" && !confirm(this.$i18n.t('cancel_confirmation'))) {
          return false
        }
        return true
      },


      successRedirect(response) {
        if(response.error){
          this.message_type = "error";
          this.message_text.push(response.error)
        }
        else {
          window.location.replace(response.path);
        }
      },
      successReturn(response) {
        return response
      },


      getHoursAndMinutes(time) {
        time = commonizeTimeFormat(time)
        return time
      },
      async submitUserInput(event){
        if(this.sitting.status == 'pending' && this.sitting.active_bookings && this.sitting.active_bookings.length > 0) {
          return
        }


        this.message_text = [];
        let send_type = 'POST'
        let path = this.base_path
        let startDate = new Date
        let endDate = new Date
        let startTime = this.getHoursAndMinutes(this.sitting.start_time)
        let endTime = this.getHoursAndMinutes(this.sitting.end_time)
        startDate.setHours(startTime.hours, startTime.minutes, 0)
        endDate.setHours(endTime.hours, endTime.minutes, 0)
        this.sitting.start_time = startDate
        this.sitting.end_time = endDate
        let userConfirm = await this.handleConfirmations();
        if(!userConfirm) {
          return;
        }
        if (this.type == "edit") {
          send_type = "PUT"
          path = `${this.base_path}/${this.sitting.id}`
        }
        sendAjaxRequest(send_type, path, 'json', {sitting: this.sitting}, this.successRedirect, this.throwError)
      },

      setErrorMessage({ valuese, errors, results }) {
        setErrorMessage(this, errors, true)
      },

      stringifyAccommodations(accommodations) {
        let accommodationNames = []
        accommodations.forEach((accommodation) => {
          accommodationNames.push(this.$i18n.t(accommodation.accommodation_type))
        })

        return accommodationNames.join(', ')
      },

      showComments(id){
        id === this.commentsItem ? this.commentsItem = 0 : this.commentsItem = id
      },

      cancelBooking(booking) {
        if (!confirm(this.$t('cancellation_warning'))) {
          return
        }
        let bookingData = booking
        bookingData.booking_id = booking.id
        bookingData.sitting_id = this.sitting.id
        bookingData.comment = this.commentText;

        sendAjaxRequest('POST', `${this.cancellation_path}/cancel_booking.json`, 'json', {booking: bookingData}, this.cancelSuccess, this.throwError)

        sendAjaxRequest('POST', `${this.cancellation_path}/cancel_booking.json`, 'json', {booking: bookingData}, this.cancelSuccess, this.throwError)
      },

      cancelSuccess(data) {
        sendAjaxRequest('GET', `${this.base_path}/${this.sitting.id}/get_bookings`, 'json', {}, this.setBookings, this.throwError)
        this.message_text = []
        this.message_text.push(this.$i18n.t('cancellation_success'));
        this.message_type = 'notice'
        this.commentsItem = ''

        this.scrollToTop()
      },

      scrollToTop() {
        window.scrollTo({top: 0, behavior: 'smooth'});
      },

      setBookings(data) {
        this.sitting.active_bookings = data
        this.loading = false
      },

      setItems(items) {
        this.bookings = items
      },

      throwError(){
        alert(_vm.$t('error_loading'));
      }
    }
 }
</script>
